export default __webpack_public_path__ + "media/images/mailer-new/heading/2fa-disabled-274c992e2b155e78bdeb9a9fff9e89fe.png";